
import { useEffect, useState } from "react";
import axios from "axios";
import you from '../images/boy.png';
import bot from '../images/happy.png';
import Subproducts from "./Subproducts";
import LoadingDots from "./LoadingDots";

function Products() {
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedCategoryName, setSelectedCategoryName] = useState(null);
const [time] =useState(new Date());
  useEffect(() => {
    axios
      .get("https://dairy-api-kzjx.onrender.com/categories")
      .then((response) => {
        if (response.data.categories?.length > 0) {
          setCategories(response.data.categories);
        } else {
          alert("No categories found.");
        }
      })
      .catch((error) => {
        console.error("Error fetching categories:", error);
        alert("Failed to fetch categories.");
      });
  }, []);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate fetching data
    setTimeout(() => setLoading(false), 1000); 
  }, []);
  

  return (
    <>
    <div className="you-time animated-frame">
            <img src={you} alt="boy" className="boy" />
            You {time?.toLocaleTimeString()}</div>
          <div className="you-message">
            <div className="frame2"><b>Explore Products</b></div>
          </div>

          <div className='chatbot'>
            <img src={bot} alt="bot" className="bot" />
            <div className='chatbot-time'>{time.toLocaleTimeString()}</div>
          </div>
      <div className="frame1 animated-frame">
        <div className="box1">
          Please choose from the following options:
          <div style={{textAlign: "center"}}>
          {categories.map((category) => (
              <button
                key={category.id}
                className="menu-btn"
                onClick={() => {
                  setSelectedCategory(category.id);
                  setSelectedCategoryName(category.name);
                }}
              >
                {category.name}
              </button>
            ))}

          </div>
        </div>
      </div>

      {selectedCategory && (
        <>
         {loading ? (
                <div className='frame1 animated-frame'>
                    <LoadingDots />
                </div>
            ) : (

              <>
               <div className="you-time animated-frame">
                <img src={you} alt="boy" className="boy" />
                You {time?.toLocaleTimeString()}</div>
              <div className="you-message">
                <div className="frame2 animated-frame"><b>{selectedCategoryName}</b></div>
              </div>

              <div className='chatbot'>
                <img src={bot} alt="bot" className="bot" />
                <div className='chatbot-time'>{time.toLocaleTimeString()}</div>
              </div>
                
                <Subproducts num1={selectedCategory} />
              </>
            )}
        </>
        )}
    </>
  );
}

export default Products;
